import {userApi} from './../../api';
import App from '../../app';
import { Award, Member, Rank, AdminRoles, Post} from '../../interfaces';


export const collection = null
export const state = {
    // name: App.State<string>(""),
}
export const computed = {

}
